import Layout from '@/layout'

export default {
  path: '/bank_accounts',
  redirect: '/bank_accounts/list',
  component: Layout,
  children: [
    {
      path: 'list',
      name: '銀行口座一覧',
      component: () => import('@/views/bank_account')
    }
  ]
}
